(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["search-template"] && !Shopify.designMode) return;
  try {
     
$('.col-sort-by').change(function () {
  
  var select_val = $(this).val();
  
  console.log(select_val);
  $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: { attributes: {'sort_options': select_val} },
      dataType: 'json',
      success: function(cart) {
        location.reload();
      }
    });  
});



  } catch(e) { console.error(e); }
})();
})();
